module.exports = __webpack_public_path__ + "static/media/dijon-13.a13c1c92.jpg";